<template>
  <div class="bg">
    <div class="title-container">
        <div class="head">
      <div class="bodyTitle">
      <!-- <img src="../../assets/Starting/img-hotspot/logo.png" /> -->
        <div class="pageTitle">热点分析</div>
      </div>
    </div>
    </div>
    <div class="main">
      <div class="info">
        <div class="hotspot-title">{{ this.topic_name }}</div>

        <div class="brief-introduction">{{ this.topic_info }}</div>
      </div>
      <div class="main-middle">
        <div class="middle-title">分渠道数据分布</div>
        <div id="charts-line"></div>
      </div>
      <div class="main-bottom">
        <div class="bottom-left">
          <div class="left-title">活跃新闻媒体来源</div>
          <div id="charts-bar"></div>
        </div>
        <div class="bottom-right">
          <div class="right-title">平台占比</div>
          <div id="charts-pie"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { word } from "../../api/re.js";
import { botMon} from "../../api/bot.js";

import echarts from "echarts";
export default {
  data() {
    return {
      topic_name: "",
      topic_info: "",
      line: "",
      bar: "",
      pie: "",
      time: [],
      goodList: [],
      news:[],
      num_index:1,
      data:"",
    };
  },
  created() {
    // this.websket()
   this.pink();
       setInterval(()=>{
      this.pink();
    },21600000)
  },

  mounted() {
    
    // this.daxian();
   setInterval(() => {   
  console.log(this.num_index,'当前下表');
    
  this.topic_name=this.news[this.num_index].text;
  this.topic_info=this.news[this.num_index].CONTENT;
  this.num_index++;
    if(this.num_index>=this.news.length){
     this.num_index=0
      console.log('只想到了'); 
    } 
  this.daxian();
   },8000)
   

  },
  methods: {
      websket() {
      // 检查浏览器是否支持SSE
      if ("EventSource" in window) {
        var source = new EventSource('http://192.168.31.156:40001/sse/connect/daxian');
        source.onmessage = function(e) {     //监听信息的传输
         this.data =e.data;
          // console.log("message1",e.data);
            // this.data = JSON.parse(e.data);
        console.log(this.data,'所接收到的信息');
        
        // origin = e.origin;
        };

        source.onopen = function(e) {   //当连接正式建立时触发
          console.log("连接打开.");

        };

        source.onerror = function(e) {  //当连接发生error时触发
          if (e.readyState == EventSource.CLOSED) {
            console.log("连接关闭");
          } else {
            console.log("onerror:" + e.readyState);
          }
        };
      } else {
        console.log("没有sse");
      }
    },
    pink(){ 
        word({
   classification:'交通',
   dataSource:'全部',
   timeType:5
     }).then((res) => {
        this.news = res.data.data;
     console.log(this.news,'woshi');
     console.log(this.news[0].text,'woshi');
        this.topic_name=this.news[0].text
     this.topic_info=this.news[0].CONTENT  
     this.daxian()
    })
    },
    daxian() {
     
      botMon({
        text: this.topic_name,
      }).then((res) => {
        this.time = res.data.data;
        this.goodList = res.data.data.classifyCount.data;
        this.lond()
        this.moon()
        var myChart = echarts.init(document.getElementById("charts-line"));
        
        // 指定图表的配置项和数据
        var option = {
          tooltip: {
            trigger: "axis",
          },
          legend: {
            icon: "circle",
                 itemWidth: 5, //小圆点宽度
             itemHeight: 5, // 小圆点高度
            itemGap: 20,
       
            data: ["网页", "抖音", "微博", "微信", "总量"],
            textStyle: {
              color: "#FFFFFF",
               fontSize: 8,
            },
            right: "4%",
            top:"-2.5%"

          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "11%",
           top:"10%",
            containLabel: true,
          },

          xAxis: {
            type: "category",
            boundaryGap: false,
            axisLabel: {
              formatter: "{value}",
              fontSize: 8,
              margin: 20,
              textStyle: {
                color: "#FFFFFF",
              },
            },
            data: res.data.data.trendOfAttention.date,
          },
          yAxis: {
            type: "value",
            axisLabel: {
                fontSize: 8,
              textStyle: {
                color: "#FFFFFF",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#FFFFFF",
                opacity: "0.2",
              },
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#FFFFFF",
                opacity: "0.7",
              },
            },
          },
          series: [
            {
              name: "网页",
              type: "line",
              stack: "Total",
              data: this.time.trendOfAttention.tw,
            },
            {
              name: "抖音",
              type: "line",
              stack: "Total",
              data: this.time.trendOfAttention.douyin,
            },
            {
              name: "微博",
              type: "line",
              stack: "Total",
              data: this.time.trendOfAttention.wb,
            },
            {
              name: "微信",
              type: "line",
              stack: "Total",
              data: this.time.trendOfAttention.wx,
            },
            {
              name: "总量",
              type: "line",
              stack: "Total",
              data: this.time.trendOfAttention.total,
            },
          ],
        };
        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option);
        window.onresize = function() {
          myChart.resize();
        };
      });
    },
      lond() {
        var option = {
          textStyle: {
            fontSize: 0,
          },
          tooltip: {
            trigger: "axis",
            extraCssText:'width:5;height:5px;'
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: 0,
            top:"12%",
            containLabel: true,
          },
          xAxis: {
            nameTextStyle: {
              color: "#c0c3cd",
              padding: [0, 0, -10, 0],
              fontSize: 14,
            },
            axisLabel: {
              interval: 0,
              rotate: 40,
              color: "#8BA0C4",
              fontWeight: 400,
              fontFamily: "SourceHanSansCN-Regular, SourceHanSansCN",
              fontSize: 8,
            },
            axisTick: {
              lineStyle: {
                color: "#0B1535",
                width: 1,
              },
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: "#384267",
                width: 1,
                type: "dashed",
              },
              show: true,
            },
            data: this.time.topOfTheMedia.Top10,
            type: "category",
          },
          yAxis: {
            type: "value",
            nameTextStyle: {
              color: "#c0c3cd",
              padding: [0, 0, -10, 0],
              fontSize: 8,
            },

            axisLabel: {
              margin: 20,
              color: "#8BA0C4",
              fontWeight: 400,
              fontFamily: "SourceHanSansCN-Regular, SourceHanSansCN",
              fontSize: 8,
            },
            axisTick: {
              lineStyle: {
                color: "#384267",
                width: 1,
              },
              show: true,
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#384267",
                type: "solid",
              },
            },
            axisLine: {
              lineStyle: {
                color: "#384267",
                width: 1,
                type: "solid",
              },
              show: true,
            },
          },
          series: [
            {
              data: this.time.topOfTheMedia.data,
              type: "bar",
              barMaxWidth: "auto",
              barWidth: 16,
              itemStyle: {
                color: {
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  type: "linear",
                  global: false,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(61, 212, 214, 1)",
                    },
                    {
                      offset: 1,
                      color: "rgba(16, 98, 255, 1)",
                    },
                  ],
                },
              },
              label: {
                show: false,
                position: "top",
                distance: 10,
                color: "#fff",
                position: [30, 10],
              },
            },
          ],
        };
        var myChart = echarts.init(document.getElementById("charts-bar"));
        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option);
        window.onresize = function() {
          myChart.resize();
        };
    },
    moon() {

        var colorList = [
          "#73DDFF",
          "#73ACFF",
          "#FDD56A",
          "#FDB36A",
          "#FD866A",
          "#9E87FF",
          "#58D5FF",
        ];
        var arr = this.goodList;
        var option = {
          color: colorList,
          title: {
            // text: 'PM2.5含量',
            // subtext:'50%',
            x: "center",
            y: "center",
            textStyle: {
              color: "#fff",
              fontSize: 8,
            },
          },
          legend: {
               show:false,
            orient: "vertical", // 'vertical'
            x: "left", // 'center' | 'left' | {number},
            y: "bottom", // 'center' | 'bottom' | {number}
            padding: 10, // [5, 10, 15, 20]
              itemWidth: 5, //小圆点宽度
             itemHeight: 5, // 小圆点高度
            itemGap: 20,
            textStyle: { color: "#c3cad9", fontSize: 8, },
          },
          tooltip: {
            trigger: "item",
         
          },
              grid: {
            left: "8%",
            right: "4%",
            bottom: "7%",
           top:"7%",
            containLabel: true,
          },
          series: [
            {
              type: "pie",
              center: ["50%", "50%"],
              radius: ["62%", "45%"],
              clockwise: true,
              avoidLabelOverlap: true,
              hoverOffset: 15,
              itemStyle: {
                normal: {
                  color: function(params) {
                    return colorList[params.dataIndex];
                  },
                },
              },
              label: {
                show: true,
                position: "outside",
                 textStyle: {
                fontSize: 1,
                          
             },
                formatter: "{a|{b}：{d}%}\n{hr|}",
                rich: {
                  hr: {
                    backgroundColor: "t",
                    borderRadius: 1,
                    width: 1,
                    height: 1,
                    padding: [0, 3, 0, -1],
                  },
                  a: {
                    padding: [-1, 1, -1, 5],
                  },
                },
              },
              labelLine: {
                normal: {
                  length: 1,
                  length2: 11,
                  lineStyle: {
                    width: 1,
                  },
                },
              },
              data: arr,
            },
          ],
        };
        var myChart = echarts.init(document.getElementById("charts-pie"));
        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option);
        window.onresize = function() {
          myChart.resize();
        };
    },
  },
};
</script>

<style lang="scss" scoped>
.bg {
  width: 100%;
  height: 100%;
  background: url("../../assets/Starting/img-hotspot/wnmq.png");
  background-size: 100% 100%;
  overflow: hidden;
  .title-container {
    height: 11%;
.head {
    margin: 0 3vw;
    display: flex;
    align-items: center;
    height: 100%;
    justify-content: space-between;
    user-select: none;
    position: relative;
    .bodyTitle {
      height: 7.4vh;
      font-size: 0.2vw;
      font-weight: bold;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
     position: relative;
     left: -20px;
      img {
        width: 20px;
        height: 20px;
      }
      .img_monitor {
        transform: rotate(180deg);
      }
      .pageTitle {
        margin: 0 0.5em;
        white-space: nowrap;
      }
    }
  }
  }
  /** 主体部分 **/
  .main {
    height: 89%;
    width: 96%;
  margin: 0 auto;
    .info {
      width: 90%;
      height: 9%;
      .hotspot-title {
        text-align: center;
        position: relative;
        font-size: 0.6rem;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #ffffff;
        line-height: 0.9rem;
        height: 100%;
        overflow:hidden;
	    text-overflow:ellipsis;
     	white-space:nowrap
        
      }
      .brief-introduction {
        width: 99%;
        margin: -1% auto;
        text-align: center;
       position: relative;
       left: 5%;
        font-size: 0.2rem;
        font-family: Myriad Pro;
        font-weight: 400;
        color: #cccccc;
        opacity: 0.7;
        line-height: 0.8rem;
          overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
        
      }
    }
    .main-middle {
      width: 100%;
      height: 35%;
      margin: 4% auto;
      background-image: url("../../assets/Starting/img-hotspot/middle1.png");
      background-size: 100% 100%;
      .middle-title {
        font-size: 0.2rem;
        color: #fff;
        position: relative;
        left: 0.5vw;
        top: 0.3vh;
      }
      #charts-line {
        width: 100%;
        height: 15vh;
        position: relative;
        top: -1vh;
      }
    }
    .main-bottom {
      width: 100%;
      height: 40%;
      margin-top: 1vh;
      .bottom-left {
        width: 49%;
        height: 100%;
      position: relative;
      top: -1.3vh;
        display: inline-block;
        background-image: url("../../assets/Starting/img-hotspot/bottoms.png");
        background-size: 100% 100%;
        .left-title {
          font-size: 0.2rem;
          position: relative;
          left: 0.5vw;
          top: 0.5vh;
          color: #fff;
        }
        #charts-bar {
          width: 100%;
         height: 80%;
        }
      }
      .bottom-right {

        width: 50%;
        float: right;
        height: 100%;
        padding: 0 0.5vw;
        position: relative;
         top: -1.3vh;
        background-image: url("../../assets/Starting/img-hotspot/bottoms.png");
        background-size: 100% 100%;
        .right-title {
          font-size: 0.2rem;
          position: relative;
          left: 0.3vw;
          top: 0.5vh;
          color: #fff;
        }
        #charts-pie {
          width: 105%;
          height: 90%;


        }
      }
    }
  }
}
</style>
